module.exports = __webpack_public_path__ + "img/order_2.206c7bbd.jpg";